/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_shipping = /** @type {(inputs: {}) => string} */ () => {
	return `Doprava`
};

const da_shipping = /** @type {(inputs: {}) => string} */ () => {
	return `Levering`
};

const de_shipping = /** @type {(inputs: {}) => string} */ () => {
	return `Versand`
};

const en_shipping = /** @type {(inputs: {}) => string} */ () => {
	return `Shipping`
};

const es_shipping = /** @type {(inputs: {}) => string} */ () => {
	return `Envío`
};

const fr_shipping = /** @type {(inputs: {}) => string} */ () => {
	return `Livraison`
};

const hu_shipping = /** @type {(inputs: {}) => string} */ () => {
	return `Szállítás`
};

const it_shipping = /** @type {(inputs: {}) => string} */ () => {
	return `Spedizione`
};

const nl_shipping = /** @type {(inputs: {}) => string} */ () => {
	return `Verzending`
};

const pl_shipping = /** @type {(inputs: {}) => string} */ () => {
	return `Wysyłka`
};

const pt_shipping = /** @type {(inputs: {}) => string} */ () => {
	return `Envio`
};

const sv_shipping = /** @type {(inputs: {}) => string} */ () => {
	return `Leverans`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const shipping = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.shipping(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("shipping", locale)
	if (locale === "cs") return cs_shipping(inputs)
	if (locale === "da") return da_shipping(inputs)
	if (locale === "de") return de_shipping(inputs)
	if (locale === "en") return en_shipping(inputs)
	if (locale === "es") return es_shipping(inputs)
	if (locale === "fr") return fr_shipping(inputs)
	if (locale === "hu") return hu_shipping(inputs)
	if (locale === "it") return it_shipping(inputs)
	if (locale === "nl") return nl_shipping(inputs)
	if (locale === "pl") return pl_shipping(inputs)
	if (locale === "pt") return pt_shipping(inputs)
	return sv_shipping(inputs)
};